<button mat-icon-button [matTooltip]="tooltip" [color]="color" (click)="onClick()">
    <img src="assets/images/icons/icon-edit.png" alt="Button Image" height="5px" width="5px" />
</button>
